<div class="spinner" [style.display]="display">
</div>